import {Component, Input } from '@angular/core';

@Component({
    selector: 'card-item',
    templateUrl: './detail-item-container.component.html',
    standalone: false
})
export class DetailItemContainerComponent {
  @Input() label: string;
  @Input() class = 'col-8';
  @Input() labelClass = 'col-2'; 
  @Input() value: string;
  @Input() prefix: string;
  @Input() class2 = 'col-8';
  @Input() value2: string;
  @Input() prefix2: string;
  @Input() show2 = false;

}
